import { DiagnosticSeverity } from 'vscode-languageserver-protocol';
import { IconDefinition } from '@ant-design/icons-svg/lib/types';
import * as icons from '@ant-design/icons-svg';
import { SvgIcon } from '../../InformationPanel/SvgIcon';

const ProblemIcon = (props: { severity: DiagnosticSeverity | undefined }) => {
  let iconDefinition: IconDefinition;
  let iconColor: string;

  if (props.severity === DiagnosticSeverity.Warning) {
    iconDefinition = icons.WarningOutlined;
    iconColor = '#b89500';
  } else if (props.severity === DiagnosticSeverity.Information) {
    iconDefinition = icons.InfoCircleOutlined;
    iconColor = 'blue';
  } else {
    iconDefinition = icons.CloseCircleOutlined;
    iconColor = '#e51400';
  }

  return <SvgIcon iconDefinition={iconDefinition} iconSize={14} color={iconColor} />;
};

export default ProblemIcon;
